export default {
  get: {
    method: 'post',
    url: '/client/activities/MODULE'
  }
}
